// removed by extract-text-webpack-plugin
module.exports = {"insetSection":"Gd2abd7 G55d311 Ge0b40c","heading":"G3af086 Gda84e6 G583c98 G75a8bf","bold":"G3ddf3b G42bbcd"};